// import Loading from "components/common/Loading";
// import Product from "components/user/Product";
// import ProductPopUp from "components/user/ProductPopUp";
// import api from "config/api";
// import { useAppDispatch, useAppSelector } from "hooks/store";
// import React, { useEffect, useMemo, useState } from "react";
// import { useSearchParams } from "react-router-dom";
// import { setPizzaList, setSelected } from "store/slices/main.slice";

// type Props = {
//   isAdmin: boolean;
// };

// const Listing = (props: Props) => {
//   const dispatch = useAppDispatch();
//   const [searchParams] = useSearchParams();
//   const [products, setproducts] = useState<any[]>([]);
//   const [loading, setLoading] = useState(false);
//   const pizzaList = useAppSelector(({ main }) => main.pizzaList);

//   const fetchData = (id: string | null, setState: boolean = false) => {
//     if (id) {
//       setLoading(true);
//       setproducts([]);
//       api
//         .get("/api/Product/ByCategoryId?categoryId=" + id)
//         .then(({ data }) => {
//           if (!pizzaList.length && id !== "7") {
//             fetchData("7");
//           }

//           if (id === "7") {
//             dispatch(setPizzaList(data));
//           }
//           if (setState) {
//             setproducts(data);
//           }
//         })
//         .finally(() => setLoading(false));
//     }
//   };

//   const product = useMemo(
//     () => searchParams.get("product"),
//     [searchParams.get("product")]
//   );
//   useEffect(() => {
//     const timeout = setTimeout(() => {
//       fetchData(product, true);
//     }, 200);
//     return () => clearTimeout(timeout);
//   }, [product]);

//   return (
//     <div className="h-full relative z-0">
//       <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 overflow-y-auto items-start max-h-full p-4 ">
//         {products.map((item) => (
//           <Product
//             {...item}
//             btnText="Add to cart"
//             onClick={() => dispatch(setSelected(item))}
//           />
//         ))}
//       </div>

//       {loading && <div className="h-44">
//         <Loading /> </div>}
//       <ProductPopUp />
//     </div>
//   );
// };

// export default Listing;

import Loading from "components/common/Loading";
import Product from "components/user/Product";
import ProductPopUp from "components/user/ProductPopUp";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import ImageNotSupportedRoundedIcon from "@mui/icons-material/ImageNotSupportedRounded";
import LocalOfferRoundedIcon from "@mui/icons-material/LocalOfferRounded";
import LocalPizzaRoundedIcon from "@mui/icons-material/LocalPizzaRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import api from "config/api";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { useEffect, useMemo, useRef, useState } from "react"; // === ADDED BY SAMPATH – 2026-01-12 ===
import { useSearchParams } from "react-router-dom";
import { setPizzaList, setSelected } from "store/slices/main.slice";
import EditProductDialog from "components/admin/EditProductDialog";

type AdminProductFilter = "all" | "deal" | "pizza" | "notPizza" | "noImage";

const Listing = () => {
  const dispatch = useAppDispatch();
  // === ADDED BY SAMPATH – 2026-01-12 ===
  // NEW: need setSearchParams to auto-select category in HorizontalBar while scrolling
  const [searchParams, setSearchParams] = useSearchParams();
  // === END SAMPATH ===
  // === ADDED BY SAMPATH – 2026-01-12 ===
  // OLD: const [searchParams] = useSearchParams();
  // === END SAMPATH ===

  const [, setproducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const pizzaList = useAppSelector(({ main }) => main.pizzaList);
  const [selectProduct, setSelectProduct] = useState<any>(undefined);
  const isAdminPage = window.location.pathname.includes("admin");
  const [adminSearch, setAdminSearch] = useState("");
  const [adminFilter, setAdminFilter] = useState<AdminProductFilter>("all");

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // NEW: get categories (same source used by HorizontalBar.tsx)
  const sideBarMenu = useAppSelector(({ main }) => main.sideBarMenu);

  // NEW: store products grouped by categoryId
  const [productsByCat, setProductsByCat] = useState<Record<number, any[]>>({});

  // NEW: section refs by categoryId for smooth scrolling
  const catSectionRefs = useRef<Record<number, HTMLDivElement | null>>({});
  const catHeaderRefs = useRef<Record<number, HTMLDivElement | null>>({});

  // NEW: guard to prevent scroll-loop when URL param changes due to auto-scroll selection
  const shouldScrollOnParamRef = useRef(false);

  // NEW: keep last auto-selected category id to reduce spam updates
  const lastAutoSelectedRef = useRef<number>(0);
  const bannerFullyVisibleRef = useRef<boolean>(true);

  // NEW: helper for smooth scroll with offset (keeps header/menu visible)
  const scrollToCategory = (id: number) => {
    const el =
      catSectionRefs.current[id] || document.getElementById(`cat-${id}`);
    if (!el) return;

    requestAnimationFrame(() => {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      // offset (HorizontalBar height + spacing)
      window.setTimeout(() => window.scrollBy({ top: -90, left: 0 }), 80);
    });
  };
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // CONTROL: grid mode -> "auto" (old setup) OR "max2" (desktop max 2, mobile 1)
  const DEFAULT_GRID_MODE: "auto" | "max2" = "max2";
  const gridMode =
    (searchParams.get("grid") as "auto" | "max2" | null) ?? DEFAULT_GRID_MODE;

  // === ADDED BY SAMPATH – 2026-01-29 ===
  // FIX: Reduce empty left/right margins on desktop by ~50% without changing grid structure.
  // - Before: max-w-6xl + px-4 (lots of side whitespace on large screens)
  // - After : max-w-7xl + px-2 md:px-3 lg:px-4 (tighter sides on desktop, still safe on mobile)
  const gridOuterClassName =
    gridMode === "max2" ? "w-full max-w-7xl mx-auto px-2 md:px-3 lg:px-4" : "w-full";
  // === END SAMPATH ===

  const gridClassName =
    gridMode === "max2"
      ? "grid grid-cols-1 md:grid-cols-2 gap-2 items-start"
      : "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-3 items-start";
  // === END SAMPATH ===

  const collectPizzaProducts = (items: any[] = []) => {
    const pizzaMap = new Map<number, any>();

    items.forEach((item: any) => {
      const isPizzaProduct = Number(item?.isPizza || 0) === 1;
      const isDealProduct = Number(item?.isDeal || 0) === 1;
      const productId = Number(item?.productId || 0);

      if (!isPizzaProduct || isDealProduct || !productId) return;
      if (!pizzaMap.has(productId)) {
        pizzaMap.set(productId, item);
      }
    });

    return Array.from(pizzaMap.values());
  };

  const mergePizzaProducts = (existing: any[] = [], incoming: any[] = []) => {
    const pizzaMap = new Map<number, any>();

    [...existing, ...incoming].forEach((item: any) => {
      const productId = Number(item?.productId || 0);
      if (!productId) return;
      if (!pizzaMap.has(productId)) {
        pizzaMap.set(productId, item);
      }
    });

    return Array.from(pizzaMap.values());
  };

  const hasProductImage = (item: any) =>
    !!(item?.imageUrl && String(item.imageUrl).trim());

  const matchesAdminSearch = (item: any) => {
    const query = adminSearch.trim().toLowerCase();
    if (!query) return true;

    return [
      item?.productName,
      item?.productDescription,
      item?.productCode,
      item?.pricedesc,
      item?.price,
      item?.takeoutprice,
      item?.deliveryprice,
    ]
      .filter((value) => value !== null && value !== undefined)
      .some((value) => String(value).toLowerCase().includes(query));
  };

  const matchesAdminFilter = (item: any) => {
    if (adminFilter === "deal") return Number(item?.isDeal || 0) === 1;
    if (adminFilter === "pizza") return Number(item?.isPizza || 0) === 1;
    if (adminFilter === "notPizza") return Number(item?.isPizza || 0) !== 1;
    if (adminFilter === "noImage") return !hasProductImage(item);
    return true;
  };

  const getVisibleProducts = (items: any[] = []) => {
    if (!isAdminPage) return items;
    return items.filter(
      (item) => matchesAdminFilter(item) && matchesAdminSearch(item)
    );
  };

  const adminFilterCounts = useMemo(() => {
    const allProducts = Object.values(productsByCat).flat();

    return {
      all: allProducts.length,
      deal: allProducts.filter((item) => Number(item?.isDeal || 0) === 1).length,
      pizza: allProducts.filter((item) => Number(item?.isPizza || 0) === 1)
        .length,
      notPizza: allProducts.filter((item) => Number(item?.isPizza || 0) !== 1)
        .length,
      noImage: allProducts.filter((item) => !hasProductImage(item)).length,
    };
  }, [productsByCat]);

  const hasVisibleAdminProducts = useMemo(() => {
    if (!isAdminPage) return true;
    return Object.values(productsByCat).some(
      (items) => getVisibleProducts(items).length > 0
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdminPage, productsByCat, adminFilter, adminSearch]);

  const product = useMemo(() => searchParams.get("product"), [searchParams]);

  const refreshCategoryProducts = async (categoryId: number) => {
    if (!categoryId) return;

    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.set("categoryId", categoryId.toString());
      if (isAdminPage) {
        params.set("showAll", "true");
      }

      const { data } = await api.get(
        "/api/Product/ByCategoryId?" + params.toString()
      );
      const refreshedAt = Date.now();
      const list = (data || []).map((item: any) => ({
        ...item,
        __imageCacheBuster: refreshedAt,
      }));

      setProductsByCat((prev) => ({
        ...prev,
        [categoryId]: list,
      }));

      if (Number(product || 0) === categoryId) {
        setproducts(list);
      }

      const pizzaProducts = collectPizzaProducts(list);
      if (pizzaProducts.length) {
        dispatch(setPizzaList(mergePizzaProducts(pizzaList, pizzaProducts)));
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchData = (id: string | null, setState: boolean = false) => {
    if (id) {
      setLoading(true);
      setproducts([]);
      const params = new URLSearchParams();
      params.set("categoryId", id);
      if (isAdminPage) {
        params.set("showAll", "true");
      }
      api
        .get("/api/Product/ByCategoryId?" + params.toString())
        .then(({ data }) => {
          const pizzaProducts = collectPizzaProducts(data || []);
          if (pizzaProducts.length) {
            dispatch(setPizzaList(mergePizzaProducts(pizzaList, pizzaProducts)));
          }
          if (setState) {
            setproducts(data);
          }
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchData(product, true);
    }, 200);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product]);

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // NEW: Fetch ALL categories products and show under category headings
  useEffect(() => {
    if (!sideBarMenu?.length) return;

    let cancelled = false;

    const run = async () => {
      setLoading(true);
      try {
        const results = await Promise.all(
          sideBarMenu.map(async ({ id }) => {
            const params = new URLSearchParams();
            params.set("categoryId", id.toString());
            if (isAdminPage) params.set("showAll", "true");

            const { data } = await api.get(
              "/api/Product/ByCategoryId?" + params.toString()
            );
            return { id: Number(id), data: data || [] };
          })
        );

        if (cancelled) return;

        const map: Record<number, any[]> = {};
        results.forEach(({ id, data }) => {
          map[id] = data;
        });

        setProductsByCat(map);

        // keep your previous "products" state alive (popup/admin logic)
        const firstCat = sideBarMenu?.[0]?.id;
        if (firstCat && map[Number(firstCat)]?.length) {
          setproducts(map[Number(firstCat)]);
        }

        const allPizzaProducts = collectPizzaProducts(
          results.flatMap(({ data }) => (Array.isArray(data) ? data : []))
        );
        dispatch(setPizzaList(allPizzaProducts));
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sideBarMenu?.length]);
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // NEW: Listen for HorizontalBar click -> enable param-scroll guard and scroll to section
  useEffect(() => {
    const handler = (e: any) => {
      const id = Number(e?.detail?.id);
      if (!id) return;
      shouldScrollOnParamRef.current = true; // allow scroll when param changes from click
      scrollToCategory(id);
    };

    window.addEventListener("dcs:categoryScroll", handler as any);

    return () => {
      window.removeEventListener("dcs:categoryScroll", handler as any);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // UPDATED: only scroll on URL param change when it was triggered by click (prevents loop while auto-selecting on scroll)
  useEffect(() => {
    const id = Number(product || 0);
    if (!id) return;

    if (shouldScrollOnParamRef.current) {
      shouldScrollOnParamRef.current = false;
      scrollToCategory(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product]);
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // NEW: Auto-select HorizontalBar category while user scrolls (IntersectionObserver)
  useEffect(() => {
    if (!sideBarMenu?.length) return;

    const ids = sideBarMenu.map((x) => Number(x.id)).filter(Boolean);
    const updateActiveCategory = () => {
      const bestId = getBestActiveId();
      if (!bestId) return;

      if (lastAutoSelectedRef.current === bestId) return;
      lastAutoSelectedRef.current = bestId;

      const current = Number(searchParams.get("product") || 0);
      if (current === bestId) return;

      const sp = new URLSearchParams(searchParams);
      sp.set("product", String(bestId));
      setSearchParams(sp, { replace: true });
    };
    const getBestActiveId = () => {
      const productScrollEl =
        document.querySelector('[data-dcs-product-scroll="true"]') as HTMLElement | null;
      const productScrollTop = Math.max(0, productScrollEl?.scrollTop || 0);
      const categoryRow = document.querySelector('[data-dcs-category-row="true"]') as HTMLElement | null;
      const anchorY = categoryRow ? categoryRow.getBoundingClientRect().bottom + 8 : 150;
      const firstId = ids[0] || 0;
      const firstHeader =
        (firstId && catHeaderRefs.current[firstId]) || null;

      if (bannerFullyVisibleRef.current || productScrollTop <= 24) {
        return firstId;
      }

      if (firstHeader) {
        const firstHeaderTop = firstHeader.getBoundingClientRect().top;
        const firstHeaderBottom = firstHeader.getBoundingClientRect().bottom;

        if (firstHeaderBottom > anchorY && firstHeaderTop <= anchorY + 140) {
          return firstId;
        }
      }

      let bestPastId = 0;
      let bestPastTop = -Infinity;
      let bestFutureId = 0;
      let bestFutureTop = Infinity;

      ids.forEach((id) => {
        const el = catSectionRefs.current[id] || document.getElementById(`cat-${id}`);
        if (!el) return;

        const top = el.getBoundingClientRect().top;

        if (top <= anchorY && top > bestPastTop) {
          bestPastTop = top;
          bestPastId = id;
        }

        if (top > anchorY && top < bestFutureTop) {
          bestFutureTop = top;
          bestFutureId = id;
        }
      });

      return bestPastId || bestFutureId || ids[0] || 0;
    };

    let raf = 0;
    const observer = new IntersectionObserver(
      () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(updateActiveCategory);
      },
      {
        // observe section visibility, but calculate the active item by top position
        root: null,
        rootMargin: "-120px 0px -55% 0px",
        threshold: [0, 0.01, 0.1, 0.25, 0.5],
      }
    );

    ids.forEach((id) => {
      const el =
        catSectionRefs.current[id] || document.getElementById(`cat-${id}`);
      if (el) observer.observe(el);
    });

    const onScrollOrResize = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateActiveCategory);
    };

    const onHeaderProgress = (event: Event) => {
      const customEvent = event as CustomEvent<{ isBannerFullyVisible?: boolean }>;
      bannerFullyVisibleRef.current = !!customEvent.detail?.isBannerFullyVisible;
      onScrollOrResize();
    };

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
    window.addEventListener("dcs:headerProgress", onHeaderProgress as EventListener);
    onScrollOrResize();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScrollOrResize as any);
      window.removeEventListener("resize", onScrollOrResize as any);
      window.removeEventListener("dcs:headerProgress", onHeaderProgress as EventListener);
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sideBarMenu?.length, productsByCat]);
  // === END SAMPATH ===

  return (
    <div className="h-full relative z-0 flex flex-col">
      <div className={gridOuterClassName}>
        {isAdminPage && (
          <div className="sticky top-0 z-20 bg-white/95 backdrop-blur-sm border-b border-slate-200 py-3">
            <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
              <label className="relative block w-full lg:max-w-[460px]">
                <SearchRoundedIcon className="!text-[20px] text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                <input
                  value={adminSearch}
                  onChange={(event) => setAdminSearch(event.target.value)}
                  placeholder="Search product name, code, description, price"
                  className="h-11 w-full rounded-[6px] border border-slate-300 bg-white pl-10 pr-10 text-[14px] font-medium text-slate-900 outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/15"
                />
                {!!adminSearch && (
                  <button
                    type="button"
                    onClick={() => setAdminSearch("")}
                    className="absolute right-2 top-1/2 inline-flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full text-slate-500 hover:bg-slate-100"
                    aria-label="Clear product search"
                  >
                    <ClearRoundedIcon className="!text-[18px]" />
                  </button>
                )}
              </label>

              <div className="flex flex-wrap items-center gap-2">
                {[
                  { value: "all", label: "All", count: adminFilterCounts.all },
                  {
                    value: "deal",
                    label: "Is Deal",
                    count: adminFilterCounts.deal,
                    icon: LocalOfferRoundedIcon,
                  },
                  {
                    value: "pizza",
                    label: "Is Pizza",
                    count: adminFilterCounts.pizza,
                    icon: LocalPizzaRoundedIcon,
                  },
                  {
                    value: "notPizza",
                    label: "Not Pizza",
                    count: adminFilterCounts.notPizza,
                    icon: LocalPizzaRoundedIcon,
                  },
                  {
                    value: "noImage",
                    label: "No Image",
                    count: adminFilterCounts.noImage,
                    icon: ImageNotSupportedRoundedIcon,
                  },
                ].map(({ value, label, count, icon: Icon }) => {
                  const active = adminFilter === value;

                  return (
                    <button
                      key={value}
                      type="button"
                      onClick={() => setAdminFilter(value as AdminProductFilter)}
                      className={`inline-flex h-10 items-center gap-2 rounded-[6px] border px-3 text-[13px] font-bold transition ${
                        active
                          ? "border-primary bg-primary text-white shadow-sm"
                          : "border-slate-300 bg-white text-slate-800 hover:border-primary/60"
                      }`}
                    >
                      {Icon && <Icon className="!text-[18px]" />}
                      <span>{label}</span>
                      <span
                        className={`rounded-full px-2 py-0.5 text-[11px] ${
                          active ? "bg-white/20 text-white" : "bg-slate-100 text-slate-600"
                        }`}
                      >
                        {count}
                      </span>
                    </button>
                  );
                })}

                {(adminSearch.trim() || adminFilter !== "all") && (
                  <button
                    type="button"
                    onClick={() => {
                      setAdminSearch("");
                      setAdminFilter("all");
                    }}
                    className="inline-flex h-10 items-center gap-1 rounded-[6px] border border-slate-300 bg-white px-3 text-[13px] font-bold text-slate-600 hover:bg-slate-50"
                  >
                    <ClearRoundedIcon className="!text-[17px]" />
                    Clear
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        <div className="flex flex-col gap-8 py-2">
          {sideBarMenu.map(({ id, categoryDescription }) => {
            const cid = Number(id);
            const list = productsByCat[cid] || [];
            const visibleList = getVisibleProducts(list);
            if (!visibleList.length) return null;

            return (
              <div
                key={cid}
                id={`cat-${cid}`}
                // === ADDED BY SAMPATH – 2026-01-12 ===
                // NEW: used by IntersectionObserver to identify the category
                data-cat-id={cid}
                // === END SAMPATH ===
                ref={(el) => {
                  catSectionRefs.current[cid] = el;
                }}
                className="w-full"
              >
                <div
                  ref={(el) => {
                    catHeaderRefs.current[cid] = el;
                  }}
                  className="sticky top-0 z-10 bg-white/90 backdrop-blur-sm py-2"
                >
                  {/* === ADDED BY SAMPATH – 2026-01-12 === */}
                  {/* UPDATED: category title font bold */}
                  <h2 className="text-deptColor font-bold text-[18px] tracking-wide">
                    {categoryDescription}
                  </h2>
                  {/* === END SAMPATH === */}
                </div>

                <div className={gridClassName}>
                  {visibleList.map((item) => {
                    const itemWithCategory = {
                      ...item,
                      prodcat: item?.prodcat ?? item?.prodCat ?? item?.categoryId ?? cid,
                      __categoryId: item?.__categoryId ?? cid,
                    };

                    return (
                    <Product
                      key={
                        item?.id ??
                        `${cid}-${item?.productId ?? Math.random()}`
                      }
                      {...itemWithCategory}
                      btnText={
                        isAdminPage
                          ? "Edit"
                          : "Add to cart"
                      }
                      onClick={() => {
                        dispatch(setSelected(itemWithCategory));
                        setSelectProduct(itemWithCategory);
                      }}
                    />
                    );
                  })}
                </div>
              </div>
            );
          })}

          {isAdminPage && !loading && !hasVisibleAdminProducts && (
            <div className="rounded-[6px] border border-dashed border-slate-300 bg-white px-4 py-10 text-center">
              <p className="text-[15px] font-bold text-slate-800">
                No products found
              </p>
              <p className="mt-1 text-[13px] text-slate-500">
                Change the search text or filter selection.
              </p>
            </div>
          )}
        </div>
      </div>

      {loading && (
        <div className="h-44">
          <Loading />
        </div>
      )}

      {isAdminPage ? (
        <EditProductDialog
          selected={selectProduct}
          setSelected={setSelectProduct}
          onComplete={(avoidRemove) => {
            if (!avoidRemove) setSelectProduct(undefined);
            const categoryId = Number(
              selectProduct?.__categoryId ||
                selectProduct?.prodcat ||
                selectProduct?.prodCat ||
                selectProduct?.categoryId ||
                product ||
                0
            );
            refreshCategoryProducts(categoryId);
          }}
        />
      ) : (
        <ProductPopUp />
      )}
    </div>
  );
};

export default Listing;
